module.exports = __webpack_public_path__ + "img/primary-amex-card.374d1575.svg";